import './install-sentry';
import './assets/styles/main.scss';

import preInitialize from './pre-initialize';
import initialize from './initialize';

preInitialize().then(canProceed => {
    if (canProceed) {
        initialize();
    }
});
